import {
  GET_ACTIVE_FBA_WAREHOUSE_TREE, GET_ACTIVE_SELF_WAREHOUSE_TREE,
  GET_ACTIVE_WAREHOUSE_TREE,
  GET_FBA_WAREHOUSE_TREE, GET_SELF_WAREHOUSE_TREE,
  GET_WAREHOUSE_TREE
} from "@/store/action-types";
import {getWarehouseGroupTree} from "@/api/warehouse";

const SET_WAREHOUSE_TREE = 'SET_WAREHOUSE_TREE';
const SET_ACTIVE_WAREHOUSE_TREE = 'SET_ACTIVE_WAREHOUSE_TREE';
const SET_FBA_WAREHOUSE_TREE = 'SET_FBA_WAREHOUSE_TREE';
const SET_ACTIVE_FBA_WAREHOUSE_TREE = 'SET_ACTIVE_FBA_WAREHOUSE_TREE';
const SET_SELF_WAREHOUSE_TREE = 'SET_SELF_WAREHOUSE_TREE';
const SET_ACTIVE_SELF_WAREHOUSE_TREE = 'SET_ACTIVE_SELF_WAREHOUSE_TREE';

const state = {
  warehouseTree: null,
  activeWarehouseTree: null,
  fbaWarehouseTree: null,
  activeFbaWarehouseTree: null,
  selfWarehouseTree: null,
  activeSelfWarehouseTree: null
};

const mutations = {
  [SET_WAREHOUSE_TREE](state, tree) {
    state.warehouseTree = tree;
  },
  [SET_ACTIVE_WAREHOUSE_TREE](state, tree) {
    state.activeWarehouseTree = tree;
  },
  [SET_FBA_WAREHOUSE_TREE](state, tree) {
    state.fbaWarehouseTree = tree;
  },
  [SET_ACTIVE_FBA_WAREHOUSE_TREE](state, tree) {
    state.activeFbaWarehouseTree = tree;
  },
  [SET_SELF_WAREHOUSE_TREE](state, tree) {
    state.selfWarehouseTree = tree;
  },
  [SET_ACTIVE_SELF_WAREHOUSE_TREE](state, tree) {
    state.activeSelfWarehouseTree = tree;
  }
};

const actions = {
  // 仓库树
  [GET_WAREHOUSE_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getWarehouseGroupTree({fba: true, self: true}).then(tree => {
        commit(SET_WAREHOUSE_TREE, tree);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // 启用仓库树
  [GET_ACTIVE_WAREHOUSE_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getWarehouseGroupTree({fba: true, self: true, active: true}).then(tree => {
        commit(SET_ACTIVE_WAREHOUSE_TREE, tree);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // FBA仓库树
  [GET_FBA_WAREHOUSE_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getWarehouseGroupTree({fba: true, self: false}).then(tree => {
        commit(SET_FBA_WAREHOUSE_TREE, tree);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // 启用FBA仓库树
  [GET_ACTIVE_FBA_WAREHOUSE_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getWarehouseGroupTree({fba: true, self: false, active: true}).then(tree => {
        commit(SET_ACTIVE_FBA_WAREHOUSE_TREE, tree);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // 自营仓库树
  [GET_SELF_WAREHOUSE_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getWarehouseGroupTree({fba: false, self: true}).then(tree => {
        commit(SET_SELF_WAREHOUSE_TREE, tree);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
  // 启用自营仓库树
  [GET_ACTIVE_SELF_WAREHOUSE_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getWarehouseGroupTree({fba: false, self: true, active: true}).then(tree => {
        commit(SET_ACTIVE_SELF_WAREHOUSE_TREE, tree);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
